export enum FdrcUsAcquirers {
  FdrcUs = 'FDRC_US',
  AdsUs = 'ADS_US',
}
